export default {
    namespaced: true,
    state: {
		endpoint: 'city',
		item: {},
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(`/state/${params.state.id}/city`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}